/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as UploadBankInfoSuccessRouteImport } from './routes/upload-bank-info-success'
import { Route as UploadBankInfoErrorRouteImport } from './routes/upload-bank-info-error'
import { Route as UploadBankInfoRouteImport } from './routes/upload-bank-info'
import { Route as UploadAddressInfoSuccessRouteImport } from './routes/upload-address-info-success'
import { Route as UploadAddressInfoErrorRouteImport } from './routes/upload-address-info-error'
import { Route as UploadAddressInfoRouteImport } from './routes/upload-address-info'
import { Route as OopsRouteImport } from './routes/oops'
import { Route as CheckTokenRouteImport } from './routes/check-token'
import { Route as AuthorizeRouteImport } from './routes/authorize'
import { Route as Layout_with_navbarRouteImport } from './routes/_layout_with_navbar'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as R404RouteImport } from './routes/404'
import { Route as AuthUploadDocumentRouteImport } from './routes/_auth/upload-document'
import { Route as AuthSafeGamingSuccessRouteImport } from './routes/_auth/safe-gaming-success'
import { Route as AuthSafeGamingRouteImport } from './routes/_auth/safe-gaming'
import { Route as AuthLayout_with_navbarRouteImport } from './routes/_auth/_layout_with_navbar'
import { Route as AuthLayout_with_full_navigationRouteImport } from './routes/_auth/_layout_with_full_navigation'
import { Route as AuthWithdrawalIndexRouteImport } from './routes/_auth/withdrawal.index'
import { Route as AuthTopupIndexRouteImport } from './routes/_auth/topup.index'
import { Route as AuthRicaricaIndexRouteImport } from './routes/_auth/ricarica.index'
import { Route as AuthPrelievoIndexRouteImport } from './routes/_auth/prelievo.index'
import { Route as AuthLayout_with_full_navigationIndexRouteImport } from './routes/_auth/_layout_with_full_navigation/index'
import { Route as AuthWithdrawalStep2RouteImport } from './routes/_auth/withdrawal.step2'
import { Route as AuthTopupStep2RouteImport } from './routes/_auth/topup.step2'
import { Route as AuthRicaricaStep2RouteImport } from './routes/_auth/ricarica.step2'
import { Route as AuthPrelievoStep2RouteImport } from './routes/_auth/prelievo.step2'
import { Route as AuthLayout_with_navbarWithdrawalDoneRouteImport } from './routes/_auth/_layout_with_navbar/withdrawal-done'
import { Route as AuthLayout_with_navbarTopupNotSuccessfulRouteImport } from './routes/_auth/_layout_with_navbar/topup-not-successful'
import { Route as AuthLayout_with_navbarTopupDoneRouteImport } from './routes/_auth/_layout_with_navbar/topup-done'
import { Route as AuthLayout_with_full_navigationSubscriptionsRouteImport } from './routes/_auth/_layout_with_full_navigation/subscriptions'
import { Route as AuthLayout_with_full_navigationSettingsRouteImport } from './routes/_auth/_layout_with_full_navigation/settings'
import { Route as AuthLayout_with_full_navigationResponsibleGamingRouteImport } from './routes/_auth/_layout_with_full_navigation/responsible-gaming'
import { Route as AuthLayout_with_full_navigationInboxRouteImport } from './routes/_auth/_layout_with_full_navigation/inbox'
import { Route as AuthLayout_with_full_navigationBonusPromotionsRouteImport } from './routes/_auth/_layout_with_full_navigation/bonus-promotions'

const Layout_with_navbarVerifyEmailLazyRouteImport = createFileRoute(
  '/_layout_with_navbar/verify-email',
)()
const AuthLayout_with_navbarWithdrawalNotSuccessfulLazyRouteImport =
  createFileRoute('/_auth/_layout_with_navbar/withdrawal-not-successful')()
const AuthLayout_with_navbarWithdrawalNotAuthorizedLazyRouteImport =
  createFileRoute('/_auth/_layout_with_navbar/withdrawal-not-authorized')()
const AuthLayout_with_full_navigationProfileLazyRouteImport = createFileRoute(
  '/_auth/_layout_with_full_navigation/profile',
)()
const AuthLayout_with_full_navigationLastWithdrawalsLazyRouteImport =
  createFileRoute('/_auth/_layout_with_full_navigation/last-withdrawals')()
const AuthLayout_with_full_navigationLastTransactionsLazyRouteImport =
  createFileRoute('/_auth/_layout_with_full_navigation/last-transactions')()
const AuthLayout_with_full_navigationAccountManagementLazyRouteImport =
  createFileRoute('/_auth/_layout_with_full_navigation/account-management')()

const UploadBankInfoSuccessRoute = UploadBankInfoSuccessRouteImport.update({
  id: '/upload-bank-info-success',
  path: '/upload-bank-info-success',
  getParentRoute: () => rootRouteImport,
} as any)
const UploadBankInfoErrorRoute = UploadBankInfoErrorRouteImport.update({
  id: '/upload-bank-info-error',
  path: '/upload-bank-info-error',
  getParentRoute: () => rootRouteImport,
} as any)
const UploadBankInfoRoute = UploadBankInfoRouteImport.update({
  id: '/upload-bank-info',
  path: '/upload-bank-info',
  getParentRoute: () => rootRouteImport,
} as any)
const UploadAddressInfoSuccessRoute =
  UploadAddressInfoSuccessRouteImport.update({
    id: '/upload-address-info-success',
    path: '/upload-address-info-success',
    getParentRoute: () => rootRouteImport,
  } as any)
const UploadAddressInfoErrorRoute = UploadAddressInfoErrorRouteImport.update({
  id: '/upload-address-info-error',
  path: '/upload-address-info-error',
  getParentRoute: () => rootRouteImport,
} as any)
const UploadAddressInfoRoute = UploadAddressInfoRouteImport.update({
  id: '/upload-address-info',
  path: '/upload-address-info',
  getParentRoute: () => rootRouteImport,
} as any)
const OopsRoute = OopsRouteImport.update({
  id: '/oops',
  path: '/oops',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckTokenRoute = CheckTokenRouteImport.update({
  id: '/check-token',
  path: '/check-token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthorizeRoute = AuthorizeRouteImport.update({
  id: '/authorize',
  path: '/authorize',
  getParentRoute: () => rootRouteImport,
} as any)
const Layout_with_navbarRoute = Layout_with_navbarRouteImport.update({
  id: '/_layout_with_navbar',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const Layout_with_navbarVerifyEmailLazyRoute =
  Layout_with_navbarVerifyEmailLazyRouteImport.update({
    id: '/verify-email',
    path: '/verify-email',
    getParentRoute: () => Layout_with_navbarRoute,
  } as any).lazy(() =>
    import('./routes/_layout_with_navbar/verify-email.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthUploadDocumentRoute = AuthUploadDocumentRouteImport.update({
  id: '/upload-document',
  path: '/upload-document',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSafeGamingSuccessRoute = AuthSafeGamingSuccessRouteImport.update({
  id: '/safe-gaming-success',
  path: '/safe-gaming-success',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSafeGamingRoute = AuthSafeGamingRouteImport.update({
  id: '/safe-gaming',
  path: '/safe-gaming',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLayout_with_navbarRoute = AuthLayout_with_navbarRouteImport.update({
  id: '/_layout_with_navbar',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLayout_with_full_navigationRoute =
  AuthLayout_with_full_navigationRouteImport.update({
    id: '/_layout_with_full_navigation',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWithdrawalIndexRoute = AuthWithdrawalIndexRouteImport.update({
  id: '/withdrawal/',
  path: '/withdrawal/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTopupIndexRoute = AuthTopupIndexRouteImport.update({
  id: '/topup/',
  path: '/topup/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRicaricaIndexRoute = AuthRicaricaIndexRouteImport.update({
  id: '/ricarica/',
  path: '/ricarica/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPrelievoIndexRoute = AuthPrelievoIndexRouteImport.update({
  id: '/prelievo/',
  path: '/prelievo/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLayout_with_full_navigationIndexRoute =
  AuthLayout_with_full_navigationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthLayout_with_full_navigationRoute,
  } as any)
const AuthLayout_with_navbarWithdrawalNotSuccessfulLazyRoute =
  AuthLayout_with_navbarWithdrawalNotSuccessfulLazyRouteImport.update({
    id: '/withdrawal-not-successful',
    path: '/withdrawal-not-successful',
    getParentRoute: () => AuthLayout_with_navbarRoute,
  } as any).lazy(() =>
    import(
      './routes/_auth/_layout_with_navbar/withdrawal-not-successful.lazy'
    ).then((d) => d.Route),
  )
const AuthLayout_with_navbarWithdrawalNotAuthorizedLazyRoute =
  AuthLayout_with_navbarWithdrawalNotAuthorizedLazyRouteImport.update({
    id: '/withdrawal-not-authorized',
    path: '/withdrawal-not-authorized',
    getParentRoute: () => AuthLayout_with_navbarRoute,
  } as any).lazy(() =>
    import(
      './routes/_auth/_layout_with_navbar/withdrawal-not-authorized.lazy'
    ).then((d) => d.Route),
  )
const AuthLayout_with_full_navigationProfileLazyRoute =
  AuthLayout_with_full_navigationProfileLazyRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthLayout_with_full_navigationRoute,
  } as any).lazy(() =>
    import('./routes/_auth/_layout_with_full_navigation/profile.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthLayout_with_full_navigationLastWithdrawalsLazyRoute =
  AuthLayout_with_full_navigationLastWithdrawalsLazyRouteImport.update({
    id: '/last-withdrawals',
    path: '/last-withdrawals',
    getParentRoute: () => AuthLayout_with_full_navigationRoute,
  } as any).lazy(() =>
    import(
      './routes/_auth/_layout_with_full_navigation/last-withdrawals.lazy'
    ).then((d) => d.Route),
  )
const AuthLayout_with_full_navigationLastTransactionsLazyRoute =
  AuthLayout_with_full_navigationLastTransactionsLazyRouteImport.update({
    id: '/last-transactions',
    path: '/last-transactions',
    getParentRoute: () => AuthLayout_with_full_navigationRoute,
  } as any).lazy(() =>
    import(
      './routes/_auth/_layout_with_full_navigation/last-transactions.lazy'
    ).then((d) => d.Route),
  )
const AuthLayout_with_full_navigationAccountManagementLazyRoute =
  AuthLayout_with_full_navigationAccountManagementLazyRouteImport.update({
    id: '/account-management',
    path: '/account-management',
    getParentRoute: () => AuthLayout_with_full_navigationRoute,
  } as any).lazy(() =>
    import(
      './routes/_auth/_layout_with_full_navigation/account-management.lazy'
    ).then((d) => d.Route),
  )
const AuthWithdrawalStep2Route = AuthWithdrawalStep2RouteImport.update({
  id: '/withdrawal/step2',
  path: '/withdrawal/step2',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTopupStep2Route = AuthTopupStep2RouteImport.update({
  id: '/topup/step2',
  path: '/topup/step2',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRicaricaStep2Route = AuthRicaricaStep2RouteImport.update({
  id: '/ricarica/step2',
  path: '/ricarica/step2',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPrelievoStep2Route = AuthPrelievoStep2RouteImport.update({
  id: '/prelievo/step2',
  path: '/prelievo/step2',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLayout_with_navbarWithdrawalDoneRoute =
  AuthLayout_with_navbarWithdrawalDoneRouteImport.update({
    id: '/withdrawal-done',
    path: '/withdrawal-done',
    getParentRoute: () => AuthLayout_with_navbarRoute,
  } as any).lazy(() =>
    import('./routes/_auth/_layout_with_navbar/withdrawal-done.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthLayout_with_navbarTopupNotSuccessfulRoute =
  AuthLayout_with_navbarTopupNotSuccessfulRouteImport.update({
    id: '/topup-not-successful',
    path: '/topup-not-successful',
    getParentRoute: () => AuthLayout_with_navbarRoute,
  } as any).lazy(() =>
    import('./routes/_auth/_layout_with_navbar/topup-not-successful.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthLayout_with_navbarTopupDoneRoute =
  AuthLayout_with_navbarTopupDoneRouteImport.update({
    id: '/topup-done',
    path: '/topup-done',
    getParentRoute: () => AuthLayout_with_navbarRoute,
  } as any).lazy(() =>
    import('./routes/_auth/_layout_with_navbar/topup-done.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthLayout_with_full_navigationSubscriptionsRoute =
  AuthLayout_with_full_navigationSubscriptionsRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => AuthLayout_with_full_navigationRoute,
  } as any).lazy(() =>
    import(
      './routes/_auth/_layout_with_full_navigation/subscriptions.lazy'
    ).then((d) => d.Route),
  )
const AuthLayout_with_full_navigationSettingsRoute =
  AuthLayout_with_full_navigationSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthLayout_with_full_navigationRoute,
  } as any).lazy(() =>
    import('./routes/_auth/_layout_with_full_navigation/settings.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthLayout_with_full_navigationResponsibleGamingRoute =
  AuthLayout_with_full_navigationResponsibleGamingRouteImport.update({
    id: '/responsible-gaming',
    path: '/responsible-gaming',
    getParentRoute: () => AuthLayout_with_full_navigationRoute,
  } as any).lazy(() =>
    import(
      './routes/_auth/_layout_with_full_navigation/responsible-gaming.lazy'
    ).then((d) => d.Route),
  )
const AuthLayout_with_full_navigationInboxRoute =
  AuthLayout_with_full_navigationInboxRouteImport.update({
    id: '/inbox',
    path: '/inbox',
    getParentRoute: () => AuthLayout_with_full_navigationRoute,
  } as any).lazy(() =>
    import('./routes/_auth/_layout_with_full_navigation/inbox.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthLayout_with_full_navigationBonusPromotionsRoute =
  AuthLayout_with_full_navigationBonusPromotionsRouteImport.update({
    id: '/bonus-promotions',
    path: '/bonus-promotions',
    getParentRoute: () => AuthLayout_with_full_navigationRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/404': typeof R404Route
  '/': typeof AuthLayout_with_full_navigationIndexRoute
  '/authorize': typeof AuthorizeRoute
  '/check-token': typeof CheckTokenRoute
  '/oops': typeof OopsRoute
  '/upload-address-info': typeof UploadAddressInfoRoute
  '/upload-address-info-error': typeof UploadAddressInfoErrorRoute
  '/upload-address-info-success': typeof UploadAddressInfoSuccessRoute
  '/upload-bank-info': typeof UploadBankInfoRoute
  '/upload-bank-info-error': typeof UploadBankInfoErrorRoute
  '/upload-bank-info-success': typeof UploadBankInfoSuccessRoute
  '/safe-gaming': typeof AuthSafeGamingRoute
  '/safe-gaming-success': typeof AuthSafeGamingSuccessRoute
  '/upload-document': typeof AuthUploadDocumentRoute
  '/verify-email': typeof Layout_with_navbarVerifyEmailLazyRoute
  '/bonus-promotions': typeof AuthLayout_with_full_navigationBonusPromotionsRoute
  '/inbox': typeof AuthLayout_with_full_navigationInboxRoute
  '/responsible-gaming': typeof AuthLayout_with_full_navigationResponsibleGamingRoute
  '/settings': typeof AuthLayout_with_full_navigationSettingsRoute
  '/subscriptions': typeof AuthLayout_with_full_navigationSubscriptionsRoute
  '/topup-done': typeof AuthLayout_with_navbarTopupDoneRoute
  '/topup-not-successful': typeof AuthLayout_with_navbarTopupNotSuccessfulRoute
  '/withdrawal-done': typeof AuthLayout_with_navbarWithdrawalDoneRoute
  '/prelievo/step2': typeof AuthPrelievoStep2Route
  '/ricarica/step2': typeof AuthRicaricaStep2Route
  '/topup/step2': typeof AuthTopupStep2Route
  '/withdrawal/step2': typeof AuthWithdrawalStep2Route
  '/account-management': typeof AuthLayout_with_full_navigationAccountManagementLazyRoute
  '/last-transactions': typeof AuthLayout_with_full_navigationLastTransactionsLazyRoute
  '/last-withdrawals': typeof AuthLayout_with_full_navigationLastWithdrawalsLazyRoute
  '/profile': typeof AuthLayout_with_full_navigationProfileLazyRoute
  '/withdrawal-not-authorized': typeof AuthLayout_with_navbarWithdrawalNotAuthorizedLazyRoute
  '/withdrawal-not-successful': typeof AuthLayout_with_navbarWithdrawalNotSuccessfulLazyRoute
  '/prelievo/': typeof AuthPrelievoIndexRoute
  '/ricarica/': typeof AuthRicaricaIndexRoute
  '/topup/': typeof AuthTopupIndexRoute
  '/withdrawal/': typeof AuthWithdrawalIndexRoute
}
export interface FileRoutesByTo {
  '/404': typeof R404Route
  '/': typeof AuthLayout_with_full_navigationIndexRoute
  '/authorize': typeof AuthorizeRoute
  '/check-token': typeof CheckTokenRoute
  '/oops': typeof OopsRoute
  '/upload-address-info': typeof UploadAddressInfoRoute
  '/upload-address-info-error': typeof UploadAddressInfoErrorRoute
  '/upload-address-info-success': typeof UploadAddressInfoSuccessRoute
  '/upload-bank-info': typeof UploadBankInfoRoute
  '/upload-bank-info-error': typeof UploadBankInfoErrorRoute
  '/upload-bank-info-success': typeof UploadBankInfoSuccessRoute
  '/safe-gaming': typeof AuthSafeGamingRoute
  '/safe-gaming-success': typeof AuthSafeGamingSuccessRoute
  '/upload-document': typeof AuthUploadDocumentRoute
  '/verify-email': typeof Layout_with_navbarVerifyEmailLazyRoute
  '/bonus-promotions': typeof AuthLayout_with_full_navigationBonusPromotionsRoute
  '/inbox': typeof AuthLayout_with_full_navigationInboxRoute
  '/responsible-gaming': typeof AuthLayout_with_full_navigationResponsibleGamingRoute
  '/settings': typeof AuthLayout_with_full_navigationSettingsRoute
  '/subscriptions': typeof AuthLayout_with_full_navigationSubscriptionsRoute
  '/topup-done': typeof AuthLayout_with_navbarTopupDoneRoute
  '/topup-not-successful': typeof AuthLayout_with_navbarTopupNotSuccessfulRoute
  '/withdrawal-done': typeof AuthLayout_with_navbarWithdrawalDoneRoute
  '/prelievo/step2': typeof AuthPrelievoStep2Route
  '/ricarica/step2': typeof AuthRicaricaStep2Route
  '/topup/step2': typeof AuthTopupStep2Route
  '/withdrawal/step2': typeof AuthWithdrawalStep2Route
  '/account-management': typeof AuthLayout_with_full_navigationAccountManagementLazyRoute
  '/last-transactions': typeof AuthLayout_with_full_navigationLastTransactionsLazyRoute
  '/last-withdrawals': typeof AuthLayout_with_full_navigationLastWithdrawalsLazyRoute
  '/profile': typeof AuthLayout_with_full_navigationProfileLazyRoute
  '/withdrawal-not-authorized': typeof AuthLayout_with_navbarWithdrawalNotAuthorizedLazyRoute
  '/withdrawal-not-successful': typeof AuthLayout_with_navbarWithdrawalNotSuccessfulLazyRoute
  '/prelievo': typeof AuthPrelievoIndexRoute
  '/ricarica': typeof AuthRicaricaIndexRoute
  '/topup': typeof AuthTopupIndexRoute
  '/withdrawal': typeof AuthWithdrawalIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/404': typeof R404Route
  '/_auth': typeof AuthRouteWithChildren
  '/_layout_with_navbar': typeof Layout_with_navbarRouteWithChildren
  '/authorize': typeof AuthorizeRoute
  '/check-token': typeof CheckTokenRoute
  '/oops': typeof OopsRoute
  '/upload-address-info': typeof UploadAddressInfoRoute
  '/upload-address-info-error': typeof UploadAddressInfoErrorRoute
  '/upload-address-info-success': typeof UploadAddressInfoSuccessRoute
  '/upload-bank-info': typeof UploadBankInfoRoute
  '/upload-bank-info-error': typeof UploadBankInfoErrorRoute
  '/upload-bank-info-success': typeof UploadBankInfoSuccessRoute
  '/_auth/_layout_with_full_navigation': typeof AuthLayout_with_full_navigationRouteWithChildren
  '/_auth/_layout_with_navbar': typeof AuthLayout_with_navbarRouteWithChildren
  '/_auth/safe-gaming': typeof AuthSafeGamingRoute
  '/_auth/safe-gaming-success': typeof AuthSafeGamingSuccessRoute
  '/_auth/upload-document': typeof AuthUploadDocumentRoute
  '/_layout_with_navbar/verify-email': typeof Layout_with_navbarVerifyEmailLazyRoute
  '/_auth/_layout_with_full_navigation/bonus-promotions': typeof AuthLayout_with_full_navigationBonusPromotionsRoute
  '/_auth/_layout_with_full_navigation/inbox': typeof AuthLayout_with_full_navigationInboxRoute
  '/_auth/_layout_with_full_navigation/responsible-gaming': typeof AuthLayout_with_full_navigationResponsibleGamingRoute
  '/_auth/_layout_with_full_navigation/settings': typeof AuthLayout_with_full_navigationSettingsRoute
  '/_auth/_layout_with_full_navigation/subscriptions': typeof AuthLayout_with_full_navigationSubscriptionsRoute
  '/_auth/_layout_with_navbar/topup-done': typeof AuthLayout_with_navbarTopupDoneRoute
  '/_auth/_layout_with_navbar/topup-not-successful': typeof AuthLayout_with_navbarTopupNotSuccessfulRoute
  '/_auth/_layout_with_navbar/withdrawal-done': typeof AuthLayout_with_navbarWithdrawalDoneRoute
  '/_auth/prelievo/step2': typeof AuthPrelievoStep2Route
  '/_auth/ricarica/step2': typeof AuthRicaricaStep2Route
  '/_auth/topup/step2': typeof AuthTopupStep2Route
  '/_auth/withdrawal/step2': typeof AuthWithdrawalStep2Route
  '/_auth/_layout_with_full_navigation/account-management': typeof AuthLayout_with_full_navigationAccountManagementLazyRoute
  '/_auth/_layout_with_full_navigation/last-transactions': typeof AuthLayout_with_full_navigationLastTransactionsLazyRoute
  '/_auth/_layout_with_full_navigation/last-withdrawals': typeof AuthLayout_with_full_navigationLastWithdrawalsLazyRoute
  '/_auth/_layout_with_full_navigation/profile': typeof AuthLayout_with_full_navigationProfileLazyRoute
  '/_auth/_layout_with_navbar/withdrawal-not-authorized': typeof AuthLayout_with_navbarWithdrawalNotAuthorizedLazyRoute
  '/_auth/_layout_with_navbar/withdrawal-not-successful': typeof AuthLayout_with_navbarWithdrawalNotSuccessfulLazyRoute
  '/_auth/_layout_with_full_navigation/': typeof AuthLayout_with_full_navigationIndexRoute
  '/_auth/prelievo/': typeof AuthPrelievoIndexRoute
  '/_auth/ricarica/': typeof AuthRicaricaIndexRoute
  '/_auth/topup/': typeof AuthTopupIndexRoute
  '/_auth/withdrawal/': typeof AuthWithdrawalIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/404'
    | '/'
    | '/authorize'
    | '/check-token'
    | '/oops'
    | '/upload-address-info'
    | '/upload-address-info-error'
    | '/upload-address-info-success'
    | '/upload-bank-info'
    | '/upload-bank-info-error'
    | '/upload-bank-info-success'
    | '/safe-gaming'
    | '/safe-gaming-success'
    | '/upload-document'
    | '/verify-email'
    | '/bonus-promotions'
    | '/inbox'
    | '/responsible-gaming'
    | '/settings'
    | '/subscriptions'
    | '/topup-done'
    | '/topup-not-successful'
    | '/withdrawal-done'
    | '/prelievo/step2'
    | '/ricarica/step2'
    | '/topup/step2'
    | '/withdrawal/step2'
    | '/account-management'
    | '/last-transactions'
    | '/last-withdrawals'
    | '/profile'
    | '/withdrawal-not-authorized'
    | '/withdrawal-not-successful'
    | '/prelievo/'
    | '/ricarica/'
    | '/topup/'
    | '/withdrawal/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/404'
    | '/'
    | '/authorize'
    | '/check-token'
    | '/oops'
    | '/upload-address-info'
    | '/upload-address-info-error'
    | '/upload-address-info-success'
    | '/upload-bank-info'
    | '/upload-bank-info-error'
    | '/upload-bank-info-success'
    | '/safe-gaming'
    | '/safe-gaming-success'
    | '/upload-document'
    | '/verify-email'
    | '/bonus-promotions'
    | '/inbox'
    | '/responsible-gaming'
    | '/settings'
    | '/subscriptions'
    | '/topup-done'
    | '/topup-not-successful'
    | '/withdrawal-done'
    | '/prelievo/step2'
    | '/ricarica/step2'
    | '/topup/step2'
    | '/withdrawal/step2'
    | '/account-management'
    | '/last-transactions'
    | '/last-withdrawals'
    | '/profile'
    | '/withdrawal-not-authorized'
    | '/withdrawal-not-successful'
    | '/prelievo'
    | '/ricarica'
    | '/topup'
    | '/withdrawal'
  id:
    | '__root__'
    | '/404'
    | '/_auth'
    | '/_layout_with_navbar'
    | '/authorize'
    | '/check-token'
    | '/oops'
    | '/upload-address-info'
    | '/upload-address-info-error'
    | '/upload-address-info-success'
    | '/upload-bank-info'
    | '/upload-bank-info-error'
    | '/upload-bank-info-success'
    | '/_auth/_layout_with_full_navigation'
    | '/_auth/_layout_with_navbar'
    | '/_auth/safe-gaming'
    | '/_auth/safe-gaming-success'
    | '/_auth/upload-document'
    | '/_layout_with_navbar/verify-email'
    | '/_auth/_layout_with_full_navigation/bonus-promotions'
    | '/_auth/_layout_with_full_navigation/inbox'
    | '/_auth/_layout_with_full_navigation/responsible-gaming'
    | '/_auth/_layout_with_full_navigation/settings'
    | '/_auth/_layout_with_full_navigation/subscriptions'
    | '/_auth/_layout_with_navbar/topup-done'
    | '/_auth/_layout_with_navbar/topup-not-successful'
    | '/_auth/_layout_with_navbar/withdrawal-done'
    | '/_auth/prelievo/step2'
    | '/_auth/ricarica/step2'
    | '/_auth/topup/step2'
    | '/_auth/withdrawal/step2'
    | '/_auth/_layout_with_full_navigation/account-management'
    | '/_auth/_layout_with_full_navigation/last-transactions'
    | '/_auth/_layout_with_full_navigation/last-withdrawals'
    | '/_auth/_layout_with_full_navigation/profile'
    | '/_auth/_layout_with_navbar/withdrawal-not-authorized'
    | '/_auth/_layout_with_navbar/withdrawal-not-successful'
    | '/_auth/_layout_with_full_navigation/'
    | '/_auth/prelievo/'
    | '/_auth/ricarica/'
    | '/_auth/topup/'
    | '/_auth/withdrawal/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  R404Route: typeof R404Route
  AuthRoute: typeof AuthRouteWithChildren
  Layout_with_navbarRoute: typeof Layout_with_navbarRouteWithChildren
  AuthorizeRoute: typeof AuthorizeRoute
  CheckTokenRoute: typeof CheckTokenRoute
  OopsRoute: typeof OopsRoute
  UploadAddressInfoRoute: typeof UploadAddressInfoRoute
  UploadAddressInfoErrorRoute: typeof UploadAddressInfoErrorRoute
  UploadAddressInfoSuccessRoute: typeof UploadAddressInfoSuccessRoute
  UploadBankInfoRoute: typeof UploadBankInfoRoute
  UploadBankInfoErrorRoute: typeof UploadBankInfoErrorRoute
  UploadBankInfoSuccessRoute: typeof UploadBankInfoSuccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/upload-bank-info-success': {
      id: '/upload-bank-info-success'
      path: '/upload-bank-info-success'
      fullPath: '/upload-bank-info-success'
      preLoaderRoute: typeof UploadBankInfoSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upload-bank-info-error': {
      id: '/upload-bank-info-error'
      path: '/upload-bank-info-error'
      fullPath: '/upload-bank-info-error'
      preLoaderRoute: typeof UploadBankInfoErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upload-bank-info': {
      id: '/upload-bank-info'
      path: '/upload-bank-info'
      fullPath: '/upload-bank-info'
      preLoaderRoute: typeof UploadBankInfoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upload-address-info-success': {
      id: '/upload-address-info-success'
      path: '/upload-address-info-success'
      fullPath: '/upload-address-info-success'
      preLoaderRoute: typeof UploadAddressInfoSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upload-address-info-error': {
      id: '/upload-address-info-error'
      path: '/upload-address-info-error'
      fullPath: '/upload-address-info-error'
      preLoaderRoute: typeof UploadAddressInfoErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upload-address-info': {
      id: '/upload-address-info'
      path: '/upload-address-info'
      fullPath: '/upload-address-info'
      preLoaderRoute: typeof UploadAddressInfoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oops': {
      id: '/oops'
      path: '/oops'
      fullPath: '/oops'
      preLoaderRoute: typeof OopsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/check-token': {
      id: '/check-token'
      path: '/check-token'
      fullPath: '/check-token'
      preLoaderRoute: typeof CheckTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authorize': {
      id: '/authorize'
      path: '/authorize'
      fullPath: '/authorize'
      preLoaderRoute: typeof AuthorizeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout_with_navbar': {
      id: '/_layout_with_navbar'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof Layout_with_navbarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout_with_navbar/verify-email': {
      id: '/_layout_with_navbar/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof Layout_with_navbarVerifyEmailLazyRouteImport
      parentRoute: typeof Layout_with_navbarRoute
    }
    '/_auth/upload-document': {
      id: '/_auth/upload-document'
      path: '/upload-document'
      fullPath: '/upload-document'
      preLoaderRoute: typeof AuthUploadDocumentRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/safe-gaming-success': {
      id: '/_auth/safe-gaming-success'
      path: '/safe-gaming-success'
      fullPath: '/safe-gaming-success'
      preLoaderRoute: typeof AuthSafeGamingSuccessRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/safe-gaming': {
      id: '/_auth/safe-gaming'
      path: '/safe-gaming'
      fullPath: '/safe-gaming'
      preLoaderRoute: typeof AuthSafeGamingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_layout_with_navbar': {
      id: '/_auth/_layout_with_navbar'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthLayout_with_navbarRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_layout_with_full_navigation': {
      id: '/_auth/_layout_with_full_navigation'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthLayout_with_full_navigationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/withdrawal/': {
      id: '/_auth/withdrawal/'
      path: '/withdrawal'
      fullPath: '/withdrawal/'
      preLoaderRoute: typeof AuthWithdrawalIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/topup/': {
      id: '/_auth/topup/'
      path: '/topup'
      fullPath: '/topup/'
      preLoaderRoute: typeof AuthTopupIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/ricarica/': {
      id: '/_auth/ricarica/'
      path: '/ricarica'
      fullPath: '/ricarica/'
      preLoaderRoute: typeof AuthRicaricaIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/prelievo/': {
      id: '/_auth/prelievo/'
      path: '/prelievo'
      fullPath: '/prelievo/'
      preLoaderRoute: typeof AuthPrelievoIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_layout_with_full_navigation/': {
      id: '/_auth/_layout_with_full_navigation/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthLayout_with_full_navigationIndexRouteImport
      parentRoute: typeof AuthLayout_with_full_navigationRoute
    }
    '/_auth/_layout_with_navbar/withdrawal-not-successful': {
      id: '/_auth/_layout_with_navbar/withdrawal-not-successful'
      path: '/withdrawal-not-successful'
      fullPath: '/withdrawal-not-successful'
      preLoaderRoute: typeof AuthLayout_with_navbarWithdrawalNotSuccessfulLazyRouteImport
      parentRoute: typeof AuthLayout_with_navbarRoute
    }
    '/_auth/_layout_with_navbar/withdrawal-not-authorized': {
      id: '/_auth/_layout_with_navbar/withdrawal-not-authorized'
      path: '/withdrawal-not-authorized'
      fullPath: '/withdrawal-not-authorized'
      preLoaderRoute: typeof AuthLayout_with_navbarWithdrawalNotAuthorizedLazyRouteImport
      parentRoute: typeof AuthLayout_with_navbarRoute
    }
    '/_auth/_layout_with_full_navigation/profile': {
      id: '/_auth/_layout_with_full_navigation/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthLayout_with_full_navigationProfileLazyRouteImport
      parentRoute: typeof AuthLayout_with_full_navigationRoute
    }
    '/_auth/_layout_with_full_navigation/last-withdrawals': {
      id: '/_auth/_layout_with_full_navigation/last-withdrawals'
      path: '/last-withdrawals'
      fullPath: '/last-withdrawals'
      preLoaderRoute: typeof AuthLayout_with_full_navigationLastWithdrawalsLazyRouteImport
      parentRoute: typeof AuthLayout_with_full_navigationRoute
    }
    '/_auth/_layout_with_full_navigation/last-transactions': {
      id: '/_auth/_layout_with_full_navigation/last-transactions'
      path: '/last-transactions'
      fullPath: '/last-transactions'
      preLoaderRoute: typeof AuthLayout_with_full_navigationLastTransactionsLazyRouteImport
      parentRoute: typeof AuthLayout_with_full_navigationRoute
    }
    '/_auth/_layout_with_full_navigation/account-management': {
      id: '/_auth/_layout_with_full_navigation/account-management'
      path: '/account-management'
      fullPath: '/account-management'
      preLoaderRoute: typeof AuthLayout_with_full_navigationAccountManagementLazyRouteImport
      parentRoute: typeof AuthLayout_with_full_navigationRoute
    }
    '/_auth/withdrawal/step2': {
      id: '/_auth/withdrawal/step2'
      path: '/withdrawal/step2'
      fullPath: '/withdrawal/step2'
      preLoaderRoute: typeof AuthWithdrawalStep2RouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/topup/step2': {
      id: '/_auth/topup/step2'
      path: '/topup/step2'
      fullPath: '/topup/step2'
      preLoaderRoute: typeof AuthTopupStep2RouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/ricarica/step2': {
      id: '/_auth/ricarica/step2'
      path: '/ricarica/step2'
      fullPath: '/ricarica/step2'
      preLoaderRoute: typeof AuthRicaricaStep2RouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/prelievo/step2': {
      id: '/_auth/prelievo/step2'
      path: '/prelievo/step2'
      fullPath: '/prelievo/step2'
      preLoaderRoute: typeof AuthPrelievoStep2RouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_layout_with_navbar/withdrawal-done': {
      id: '/_auth/_layout_with_navbar/withdrawal-done'
      path: '/withdrawal-done'
      fullPath: '/withdrawal-done'
      preLoaderRoute: typeof AuthLayout_with_navbarWithdrawalDoneRouteImport
      parentRoute: typeof AuthLayout_with_navbarRoute
    }
    '/_auth/_layout_with_navbar/topup-not-successful': {
      id: '/_auth/_layout_with_navbar/topup-not-successful'
      path: '/topup-not-successful'
      fullPath: '/topup-not-successful'
      preLoaderRoute: typeof AuthLayout_with_navbarTopupNotSuccessfulRouteImport
      parentRoute: typeof AuthLayout_with_navbarRoute
    }
    '/_auth/_layout_with_navbar/topup-done': {
      id: '/_auth/_layout_with_navbar/topup-done'
      path: '/topup-done'
      fullPath: '/topup-done'
      preLoaderRoute: typeof AuthLayout_with_navbarTopupDoneRouteImport
      parentRoute: typeof AuthLayout_with_navbarRoute
    }
    '/_auth/_layout_with_full_navigation/subscriptions': {
      id: '/_auth/_layout_with_full_navigation/subscriptions'
      path: '/subscriptions'
      fullPath: '/subscriptions'
      preLoaderRoute: typeof AuthLayout_with_full_navigationSubscriptionsRouteImport
      parentRoute: typeof AuthLayout_with_full_navigationRoute
    }
    '/_auth/_layout_with_full_navigation/settings': {
      id: '/_auth/_layout_with_full_navigation/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthLayout_with_full_navigationSettingsRouteImport
      parentRoute: typeof AuthLayout_with_full_navigationRoute
    }
    '/_auth/_layout_with_full_navigation/responsible-gaming': {
      id: '/_auth/_layout_with_full_navigation/responsible-gaming'
      path: '/responsible-gaming'
      fullPath: '/responsible-gaming'
      preLoaderRoute: typeof AuthLayout_with_full_navigationResponsibleGamingRouteImport
      parentRoute: typeof AuthLayout_with_full_navigationRoute
    }
    '/_auth/_layout_with_full_navigation/inbox': {
      id: '/_auth/_layout_with_full_navigation/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthLayout_with_full_navigationInboxRouteImport
      parentRoute: typeof AuthLayout_with_full_navigationRoute
    }
    '/_auth/_layout_with_full_navigation/bonus-promotions': {
      id: '/_auth/_layout_with_full_navigation/bonus-promotions'
      path: '/bonus-promotions'
      fullPath: '/bonus-promotions'
      preLoaderRoute: typeof AuthLayout_with_full_navigationBonusPromotionsRouteImport
      parentRoute: typeof AuthLayout_with_full_navigationRoute
    }
  }
}

interface AuthLayout_with_full_navigationRouteChildren {
  AuthLayout_with_full_navigationBonusPromotionsRoute: typeof AuthLayout_with_full_navigationBonusPromotionsRoute
  AuthLayout_with_full_navigationInboxRoute: typeof AuthLayout_with_full_navigationInboxRoute
  AuthLayout_with_full_navigationResponsibleGamingRoute: typeof AuthLayout_with_full_navigationResponsibleGamingRoute
  AuthLayout_with_full_navigationSettingsRoute: typeof AuthLayout_with_full_navigationSettingsRoute
  AuthLayout_with_full_navigationSubscriptionsRoute: typeof AuthLayout_with_full_navigationSubscriptionsRoute
  AuthLayout_with_full_navigationAccountManagementLazyRoute: typeof AuthLayout_with_full_navigationAccountManagementLazyRoute
  AuthLayout_with_full_navigationLastTransactionsLazyRoute: typeof AuthLayout_with_full_navigationLastTransactionsLazyRoute
  AuthLayout_with_full_navigationLastWithdrawalsLazyRoute: typeof AuthLayout_with_full_navigationLastWithdrawalsLazyRoute
  AuthLayout_with_full_navigationProfileLazyRoute: typeof AuthLayout_with_full_navigationProfileLazyRoute
  AuthLayout_with_full_navigationIndexRoute: typeof AuthLayout_with_full_navigationIndexRoute
}

const AuthLayout_with_full_navigationRouteChildren: AuthLayout_with_full_navigationRouteChildren =
  {
    AuthLayout_with_full_navigationBonusPromotionsRoute:
      AuthLayout_with_full_navigationBonusPromotionsRoute,
    AuthLayout_with_full_navigationInboxRoute:
      AuthLayout_with_full_navigationInboxRoute,
    AuthLayout_with_full_navigationResponsibleGamingRoute:
      AuthLayout_with_full_navigationResponsibleGamingRoute,
    AuthLayout_with_full_navigationSettingsRoute:
      AuthLayout_with_full_navigationSettingsRoute,
    AuthLayout_with_full_navigationSubscriptionsRoute:
      AuthLayout_with_full_navigationSubscriptionsRoute,
    AuthLayout_with_full_navigationAccountManagementLazyRoute:
      AuthLayout_with_full_navigationAccountManagementLazyRoute,
    AuthLayout_with_full_navigationLastTransactionsLazyRoute:
      AuthLayout_with_full_navigationLastTransactionsLazyRoute,
    AuthLayout_with_full_navigationLastWithdrawalsLazyRoute:
      AuthLayout_with_full_navigationLastWithdrawalsLazyRoute,
    AuthLayout_with_full_navigationProfileLazyRoute:
      AuthLayout_with_full_navigationProfileLazyRoute,
    AuthLayout_with_full_navigationIndexRoute:
      AuthLayout_with_full_navigationIndexRoute,
  }

const AuthLayout_with_full_navigationRouteWithChildren =
  AuthLayout_with_full_navigationRoute._addFileChildren(
    AuthLayout_with_full_navigationRouteChildren,
  )

interface AuthLayout_with_navbarRouteChildren {
  AuthLayout_with_navbarTopupDoneRoute: typeof AuthLayout_with_navbarTopupDoneRoute
  AuthLayout_with_navbarTopupNotSuccessfulRoute: typeof AuthLayout_with_navbarTopupNotSuccessfulRoute
  AuthLayout_with_navbarWithdrawalDoneRoute: typeof AuthLayout_with_navbarWithdrawalDoneRoute
  AuthLayout_with_navbarWithdrawalNotAuthorizedLazyRoute: typeof AuthLayout_with_navbarWithdrawalNotAuthorizedLazyRoute
  AuthLayout_with_navbarWithdrawalNotSuccessfulLazyRoute: typeof AuthLayout_with_navbarWithdrawalNotSuccessfulLazyRoute
}

const AuthLayout_with_navbarRouteChildren: AuthLayout_with_navbarRouteChildren =
  {
    AuthLayout_with_navbarTopupDoneRoute: AuthLayout_with_navbarTopupDoneRoute,
    AuthLayout_with_navbarTopupNotSuccessfulRoute:
      AuthLayout_with_navbarTopupNotSuccessfulRoute,
    AuthLayout_with_navbarWithdrawalDoneRoute:
      AuthLayout_with_navbarWithdrawalDoneRoute,
    AuthLayout_with_navbarWithdrawalNotAuthorizedLazyRoute:
      AuthLayout_with_navbarWithdrawalNotAuthorizedLazyRoute,
    AuthLayout_with_navbarWithdrawalNotSuccessfulLazyRoute:
      AuthLayout_with_navbarWithdrawalNotSuccessfulLazyRoute,
  }

const AuthLayout_with_navbarRouteWithChildren =
  AuthLayout_with_navbarRoute._addFileChildren(
    AuthLayout_with_navbarRouteChildren,
  )

interface AuthRouteChildren {
  AuthLayout_with_full_navigationRoute: typeof AuthLayout_with_full_navigationRouteWithChildren
  AuthLayout_with_navbarRoute: typeof AuthLayout_with_navbarRouteWithChildren
  AuthSafeGamingRoute: typeof AuthSafeGamingRoute
  AuthSafeGamingSuccessRoute: typeof AuthSafeGamingSuccessRoute
  AuthUploadDocumentRoute: typeof AuthUploadDocumentRoute
  AuthPrelievoStep2Route: typeof AuthPrelievoStep2Route
  AuthRicaricaStep2Route: typeof AuthRicaricaStep2Route
  AuthTopupStep2Route: typeof AuthTopupStep2Route
  AuthWithdrawalStep2Route: typeof AuthWithdrawalStep2Route
  AuthPrelievoIndexRoute: typeof AuthPrelievoIndexRoute
  AuthRicaricaIndexRoute: typeof AuthRicaricaIndexRoute
  AuthTopupIndexRoute: typeof AuthTopupIndexRoute
  AuthWithdrawalIndexRoute: typeof AuthWithdrawalIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLayout_with_full_navigationRoute:
    AuthLayout_with_full_navigationRouteWithChildren,
  AuthLayout_with_navbarRoute: AuthLayout_with_navbarRouteWithChildren,
  AuthSafeGamingRoute: AuthSafeGamingRoute,
  AuthSafeGamingSuccessRoute: AuthSafeGamingSuccessRoute,
  AuthUploadDocumentRoute: AuthUploadDocumentRoute,
  AuthPrelievoStep2Route: AuthPrelievoStep2Route,
  AuthRicaricaStep2Route: AuthRicaricaStep2Route,
  AuthTopupStep2Route: AuthTopupStep2Route,
  AuthWithdrawalStep2Route: AuthWithdrawalStep2Route,
  AuthPrelievoIndexRoute: AuthPrelievoIndexRoute,
  AuthRicaricaIndexRoute: AuthRicaricaIndexRoute,
  AuthTopupIndexRoute: AuthTopupIndexRoute,
  AuthWithdrawalIndexRoute: AuthWithdrawalIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface Layout_with_navbarRouteChildren {
  Layout_with_navbarVerifyEmailLazyRoute: typeof Layout_with_navbarVerifyEmailLazyRoute
}

const Layout_with_navbarRouteChildren: Layout_with_navbarRouteChildren = {
  Layout_with_navbarVerifyEmailLazyRoute:
    Layout_with_navbarVerifyEmailLazyRoute,
}

const Layout_with_navbarRouteWithChildren =
  Layout_with_navbarRoute._addFileChildren(Layout_with_navbarRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  R404Route: R404Route,
  AuthRoute: AuthRouteWithChildren,
  Layout_with_navbarRoute: Layout_with_navbarRouteWithChildren,
  AuthorizeRoute: AuthorizeRoute,
  CheckTokenRoute: CheckTokenRoute,
  OopsRoute: OopsRoute,
  UploadAddressInfoRoute: UploadAddressInfoRoute,
  UploadAddressInfoErrorRoute: UploadAddressInfoErrorRoute,
  UploadAddressInfoSuccessRoute: UploadAddressInfoSuccessRoute,
  UploadBankInfoRoute: UploadBankInfoRoute,
  UploadBankInfoErrorRoute: UploadBankInfoErrorRoute,
  UploadBankInfoSuccessRoute: UploadBankInfoSuccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
